import { Component, inject } from "@angular/core";
import { CardModalService } from "@shared/card-modal";
import { TranslateModule } from "@ngx-translate/core";
import { JumpstartComponentsModule } from "@wk/components-v3-angular17";

@Component({
    selector: "wk-panel-icon-phone",
    imports: [TranslateModule, JumpstartComponentsModule],
    templateUrl: "./panel-icon-phone.component.html",
    host: { class: "wk-cm__header__icon wk-cm__header__icon-phone" },
})
export class PanelIconPhoneComponent {
    public readonly cardModalService = inject(CardModalService);
}
